import { useNavigate, useParams } from '@tanstack/react-router';
import { useEffect } from 'react';

import { useBoardDetailData } from '@/features/boards/ui/save-to-boards/hooks/use-board-detail-data';
import { BoardDetailSection } from './ui/detail/board-detail.section';

export function BoardDetailPage() {
  const { boardId } = useParams({ from: '/workspace/$workspaceId/boards/$boardId' });
  const navigate = useNavigate({ from: '/workspace/$workspaceId/boards/$boardId' });

  const {
    board,
    posts,
    isLoading,
    isBoardsLoading,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
  } = useBoardDetailData(boardId);

  useEffect(() => {
    if (isBoardsLoading || board) return;
    navigate({ to: '/workspace/$workspaceId/boards' });
  }, [board, isBoardsLoading, navigate]);

  if (!board) return null;

  return (
    <BoardDetailSection
      boardId={boardId}
      title={board.title}
      updatedAt={board.updated_at}
      postCount={board.post_count}
      posts={posts}
      isLoading={isLoading}
      isFetchingNextPage={isFetchingNextPage}
      hasNextPage={hasNextPage}
      onLoadMore={() => {
        void fetchNextPage();
      }}
      onBack={() => navigate({ to: '/workspace/$workspaceId/boards' })}
    />
  );
}
